
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/guild/voting",
      function () {
        return require("private-next-pages/[locale]/guild/voting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/guild/voting"])
      });
    }
  